import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import { useMemo } from 'react';

const useDefaultFilterReward = () => {
  const { user } = useUser();
  const defaultFilter = useMemo(() => {
    const defaultF = {
      fromDate: dayjs().startOf('month'),
      toDate: dayjs(),
    };

    if (user?.isAdmin || user?.isHO || user?.isNS) {
      return {
        ...defaultF,
        plantId: 'all',
        employeeId: null,
      };
    } else {
      return {
        ...defaultF,
        plantId: (user as any)?.plantCode,
        employeeId:
          (user as any)?.employeeId || user?.fullName || `${user?.id}_ID`,
      };
    }
  }, [user]);

  return defaultFilter;
};

export default useDefaultFilterReward;
